(function () {
  "use strict";

  var module = angular.module("uwAgenda.agenda");

  // click-directive to edit an appointment
  module.directive("agendaAppointmentEdit", [
    "$state",
    "$uibModalStack",
    "SharedAgendaService",
    "AppointmentDetailService",
    "AppointmentService",
    "Appointment",
    "DateService",
    "Alert",
    function (
      $state,
      $uibModalStack,
      SharedAgendaService,
      AppointmentDetailService,
      AppointmentService,
      Appointment,
      DateService,
      Alert
    ) {
      var directive = {
        link: link,
        restrict: "A",
        scope: {
          agendaId: "<", // related agenda
          id: "<", // appointment id
        },
      };
      return directive;

      function link(scope, element) {
        // click listener
        element.on("click", function (event) {
          event.stopPropagation();
          edit();
        });

        // edit
        function edit() {
          // close all possible open modals
          $uibModalStack.dismissAll();

          // edit appointment
          AppointmentService.get(scope.id).then(function (appointmentForEdit) {
            
            if (appointmentForEdit.deleted) {
              Alert.error("no_edit_deleted_appointment");
              return;
            }

            // get selected agenda in overview service
            var agenda = SharedAgendaService.getAgenda(scope.agendaId);

            // no time checks needed
            AppointmentDetailService.data.doTimeChecks = false;
            AppointmentDetailService.data.time.hour = null;
            AppointmentDetailService.data.time.minute = null;
            // add agenda to service
            AppointmentDetailService.data.agenda = agenda;

            // set needed values -> agenda-lables and appointment-types of agenda
            AppointmentDetailService.setEmail(
                agenda.owner.caption,
                agenda.owner.mainEmail
            );
            AppointmentDetailService.setMobile(
                agenda.owner.caption,
                agenda.owner.mainMobile
            );

            var appointment = new Appointment();
            appointment.extend(appointmentForEdit);
            
            var label = {
              daySchemeTimeId: appointmentForEdit.fK_DaySchemeTime,
              appointmentId: appointmentForEdit.id,
              isAppointment: true,
              hideTime: appointmentForEdit.hideTime,
              hour: appointmentForEdit.hour,
              minute: appointmentForEdit.minute,
              agendaLabelText: appointmentForEdit.agendaLabel.text,
              timeCaption: `${appointmentForEdit.hour.toString().padStart(2, '0')}:${appointmentForEdit.minute.toString().padStart(2, '0')}`
            };

            // copy appointment agendalabel properties to custom UI label
            Object.assign(label, appointmentForEdit.agendaLabel);

            AppointmentDetailService.data.agendaItem = label;

            // we have to set the correct date (if needed)
            // switch date
            DateService.date(new Date(appointment.appointmentDate));

            // add the appointment to the service
            AppointmentDetailService.data.appointment = appointment;

            //todo: edit agenda day time
            $state.go("Home.Agenda_Appointment");
          });
        }

        // on destroy
        scope.$on("$destroy", function () {
          element.off("click");
        });
      }
    },
  ]);
})();
